var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCkArrowRightBlack16Px = function SvgCkArrowRightBlack16Px(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.16656 4L6.22656 4.94L9.2799 8L6.22656 11.06L7.16656 12L11.1666 8L7.16656 4Z",
    fill: "#05141F"
  })));
};
export { SvgCkArrowRightBlack16Px as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTcuMTY2NTYgNEw2LjIyNjU2IDQuOTRMOS4yNzk5IDhMNi4yMjY1NiAxMS4wNkw3LjE2NjU2IDEyTDExLjE2NjYgOEw3LjE2NjU2IDRaIiBmaWxsPSIjMDUxNDFGIi8+Cjwvc3ZnPgo=";